import Logger from "logger/logger"
import {Observable, Subscription} from "rxjs"

type TOnEmit<T> = T extends (infer R)[] ? R[] : T

export function onEmit<T>(
  source$: Observable<TOnEmit<T>>,
  nextFn: (value: TOnEmit<T>) => void
): Subscription {
  return source$.subscribe({next: nextFn, error: Logger})
}
